export const fmt = (n) => Number(n || 0).toLocaleString('th-TH');
export const thb = (n) => '฿' + fmt(n);
